import { useDarkMode, withStyles } from '@glu/theming';
import PropTypes from 'prop-types';
import React from 'react';

const styles = ({ typography, palette }) => ({
  root: {
    border: 'none'
  },

  legend: {
    fontSize: typography.fontSize,
    fontFamily: typography.fontFamily,
    ...typography.h4
  },

  legendDark: {
    color: palette.text.light
  }
});

const Fieldset = ({
  legend, children, classes, className
}) => {
  const isDark = useDarkMode();
  return (
    <fieldset className={`${classes.root} ${className}`}>
      <legend className={`${classes.legend} ${isDark ? classes.legendDark : ''}`}>{legend}</legend>

      {children}
    </fieldset>
  );
};

Fieldset.propTypes = {
  legend: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string
};

Fieldset.defaultProps = {
  className: ''
};

export default withStyles(styles)(Fieldset);
